import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import UpdateFlowStep from './UpdateFlowStep'

class WorkHoursStep extends UpdateFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.update.steps.work_hours.title'),
      component,
      i18n.t('contract_versions.flows.update.steps.work_hours.description')
    )
  }
}

export default WorkHoursStep
